import React from 'react';
import Alert from '@mui/material/Alert';
import WarningIcon from '@mui/icons-material/Warning';
import AlertTitle from '@mui/material/AlertTitle';
import { useLocation } from 'react-router-dom';
import { getUserPortalRole } from '@/core/web-storage/webStorage.utils';
import { PORTAL_ROLES } from '@/authorization/authorization.constants';

export interface SystemAlertProps {
  title?: string;
  description: string | JSX.Element;
}

function SystemAlert({ title, description }: SystemAlertProps) {
  const location = useLocation();
  const userRole = getUserPortalRole();
  return (
    <>
      {location.pathname === '/dashboard' && userRole !== PORTAL_ROLES.ATA ? (
        <Alert variant="standard" icon={<WarningIcon fontSize="inherit" />} severity="info">
          {title && <AlertTitle>{title}</AlertTitle>}
          {`Notice: ${description}`}
        </Alert>
      ) : null}
    </>
  );
}

export default SystemAlert;
